'use client'
import classNames from 'classnames'
import React from 'react'
import styles from './AddressPickerMobile.module.scss'
import { ChevronDownIcon, IconSize } from '@/tools/ui'

interface Props {
  addressText: string
}
export const AddressPickerMobile: React.FC<Props> = ({ addressText }) => (
  <div
    className={classNames(styles.addressPickerMobile, 'pintxo-typography-callout2')}
    data-test-id="address-picker"
  >
    <div className={styles.address}>
      <div className={styles.addressText}>{addressText}</div>
      <ChevronDownIcon className={styles.arrow} size={IconSize.small} />
    </div>
  </div>
)
